
import * as appsettings from "../appsettings";

let occupancyRegionHours: any;
let LGroupNotActive = "Groep niet actief";
let PresentationDate = new Date(new Date().toDateString());

/**
 * Load tree data
 * @param {datetime} selectedDate
 */
function loadOccupancyRegionNodes(selectedDate: Date): void {
    $.ajax({
        type: "GET",
        async: false,
        url: appsettings.getUrl("OccupancyRegion/OccupancyRegionNodes"),
        data: { selectedDate: selectedDate },
        success: function (responseData) {
            if (responseData != undefined) {
                $('#POccupancy').html(responseData);
                loadNotOccupiedGroups();
            }
        }
    });
}

/**
* Hover current hour with light blue
* Build popup for total counters
* @param {Object} e
* @param {number} hour
* @param {number} minute
*/
function hoverCurrentQuarter(e: MouseEvent | null, quarterElement: HTMLElement | null, hour: number, minute: number): void {
    $('.stripes li:nth-child(' + (1 + (hour * 4) + (minute / 15)) + ')').css('background', 'rgba(200, 225, 239, 0.8)');

    if (quarterElement != null) {
        const control = quarterElement.parentNode.parentNode.parentNode;
        const groupId = (control as any).id.replace('groupPanel_', '');
        buildPopup(groupId, hour, minute);
    }

    if (e != null) {
        $('#DResult').fadeIn(0);
        if ($('#DResult').length > 0) {
            const treeWidth = ($('#NodeTree')[0]) ? $('#NodeTree')[0].clientWidth : 0;
            const menuWidth = ($('#ModuleMenu')[0]) ? $('#ModuleMenu')[0].clientWidth : 0;
            const popupWidth = ($('#DResult')[0]) ? $('#DResult')[0].clientWidth : 0;
            const headerHight = ($('#headerPane')[0]) ? $('#headerPane')[0].clientHeight : 0;
            const breadcrumbHeight = ($('#BreadcrumbArea')[0]) ? $('#BreadcrumbArea')[0].clientHeight : 0;
            $('#DResult').css({ top: (e.clientY + (e.pageY - e.clientY) - headerHight - breadcrumbHeight) + 'px', left: (e.clientX - treeWidth - menuWidth - popupWidth - 20) + 'px' });
        }
    }
}

/**
* Unhover current hour, color back to normal light grey
* Hide popup wiht total counters
* @param {number} hour
* @param {number} minute
*/
function unhoverCurrentQuarter(hour: number, minute: number): void {
    $('.stripes li:nth-child(' + (1 + (hour * 4) + (minute / 15)) + ')').css('background', 'rgba(225, 228, 232, 0.4)');

    $('#DResult').fadeOut(0);
}

/**
 * Build pop up wiht total counters from array
 * @param {string} groupId
 * @param {number} hour
 * @param {number} minute
 */
function buildPopup(groupId: number, hour: number, minute: number): void {
    const serviceFunctions = $(`#groupPanel_${groupId} div:first-child ul:nth-child(2) li`);

    let ih = '<b>Overbezetting:</b>';
    ih += '<div style="display: table-row;">';

    ih += '<div style="display: table-cell;">';
    for (let i = 0; i < serviceFunctions.length; i++) {
        const sf = serviceFunctions[i];
        ih += '<div>' + sf.children[0].innerHTML + '</div>';
    }
    ih += '</div>';

    ih += '<div style="display: table-cell; text-align: right">';
    for (let i = 0; i < serviceFunctions.length; i++) {
        const sf = serviceFunctions[i];
        const serviceFunctionId = sf.children[0].id;
        const occupancy = occupancyRegionHours[groupId][serviceFunctionId]['Hour' + hour + zeroPad(minute, 2)];

        if (occupancy == -1) {
            ih += '<div> ' + LGroupNotActive + '</div>';
        } else {
            ih += '<div> ' + occupancy + ' %</div>';
        }
    }
    ih += '</div>';

    ih += '</div>';

    if ($('#DResult').length > 0) {
        $('#DResult')[0].innerHTML = ih;
    }
}

/**
* Zero pad, for minute 0 to 00
* @param {number} num
* @param {number} places
*/
function zeroPad(num: number, places: number): string {
    const zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join('0') + num;
}

/**
 * Load group data
 * @param {any} groupId
 * @param {any} selectedDate
 */
function loadGroupData(groupId: number, selectedDate: Date): void {
    $.ajax({
        type: "GET",
        async: false,
        url: appsettings.getUrl("OccupancyRegion/OccupancyRegionGroup"),
        data: { groupId: groupId, selectedDate: selectedDate },
        success: function (responseData) {
            if (responseData != undefined) {
                refreshDetailsGroup(groupId, responseData.HTMLDetailsGroup);
                refreshOccupancyHours(groupId, responseData.ServiceFunctions);
            }
        }
    });
}

/**
 * Load HTML data in div
 * And set hover to current quarter
 * @param {number} groupId
 * @param {string} htmlData
 */
function refreshDetailsGroup(groupId: number, htmlData: string): void {
    $(`#groupPanel_${groupId}`).html(htmlData);

    addHoverFunctions();

    const d = new Date();
    let hour = d.getHours();
    let minute = Number((d.getMinutes() - (d.getMinutes() % 15)).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false }));
    hoverCurrentQuarter(null, null, hour, minute);
}

/**
* Build javascript object array with total counters
* [groupID][serviceFunctionId][Hour015: 67]
* @param {any} jsonData
*/
function refreshOccupancyHours(groupId: number, jsonData: any): void {
    for (let s = 0; s < jsonData.length; s++) {
        const serviceFunctions: any = {};

        const { ServiceFunctionID, DayCounters } = jsonData[s];

        const dayData: any = {};
        for (let q = 0; q < DayCounters.length; q++) {
            const { K, V } = DayCounters[q];

            dayData['Hour' + K] = V;
        }

        serviceFunctions[ServiceFunctionID] = dayData;

        if (occupancyRegionHours[groupId] == null) {
            occupancyRegionHours[groupId] = serviceFunctions;
        } else {
            occupancyRegionHours[groupId] = Object.assign(occupancyRegionHours[groupId], serviceFunctions);
        }
    }
}



/* To set PresentationDate from outside module */
/* usedto be PresentationDate: PresentationDate,*/
export function setPresentationDate(date: Date): void {
    PresentationDate = date;
}

/**
 * Page initilization
 * @param {any} selectedDate
 */
export function initialize(selectedDate: Date, lGroupNotActive: string): void {
    occupancyRegionHours = {};
    LGroupNotActive = lGroupNotActive;
    PresentationDate = selectedDate;

    loadOccupancyRegionNodes(selectedDate);
}

/**
 * Calender date changed
 * @param {Object} e
 */
export function onChangeCSelectedDate(): void {
    const selectedDate = this.value().toDateString();
    PresentationDate = selectedDate;

    loadOccupancyRegionNodes(selectedDate);
}

/**
 * Listbox no occupancy date clicked
 * @param {any} e
 */
export function onClickLBNoOccupancyDay(e: kendo.ui.ListBoxEvent): void {

    const element = e.sender.select();
    if (!element || element.length === 0) return;

    const item = e.sender.dataItem(element[0]) as ListBoxItem;
    if (!item?.Value) return;

    const selectedDate = new Date(item.Value);
    if (isNaN(selectedDate.getTime())) return;

    PresentationDate = selectedDate;

    const calendar = $("#CSelectedDate").data("kendoCalendar");
    calendar.value(selectedDate);

    loadOccupancyRegionNodes(selectedDate);
}

/**
 * Load all data collapsed/not occupied groups
 */
export function loadNotOccupiedGroups(): void {
    const groupPanels = $('[id^=groupPanel_');

    for (let i = 0; i < groupPanels.length; i++) {
        const gp = groupPanels[i];
        const groupId = gp.id.replace('groupPanel_', '');

        /*if(!$('[id^=groupPanel_'+ groupId + '').css('display')) {*/
        if (gp.style.display != 'none') {
            loadGroupData(Number(groupId), PresentationDate);
        }
    }
}

/**
 * Toggle div to show node details
 * @param {any} obj
 */
////export function toggleNode(obj: any): void {
////    if (obj.parentNode.getElementsByTagName('div').length > 0) {
////        if (obj.src.indexOf('collapse') != -1) {
////            obj.src = obj.src.replace('collapse', 'expand');
////            obj.parentNode.getElementsByTagName('div')[0].style.display = 'none';
////        } else {
////            obj.src = obj.src.replace('expand', 'collapse');
////            obj.parentNode.getElementsByTagName('div')[0].style.display = 'block';
////        }
////    }
////}

export function toggleNode(img: HTMLImageElement): void {

    const parent = img.parentElement;
    if (!parent) return;

    const content = parent.querySelector<HTMLDivElement>('div');
    if (!content) return;

    const isCollapsed = img.src.includes('collapse');

    if (isCollapsed) {
        img.src = img.src.replace('collapse', 'expand');
        content.style.display = 'none';
    } else {
        img.src = img.src.replace('expand', 'collapse');
        content.style.display = 'block';
    }
}

/**
 * Toggle div to show group details
 * @param {HTMLImageElement} img
 */
export function toggleGroup(img: HTMLImageElement): void {

    const parent = img.parentElement;
    if (!parent) return;

    const content = parent.querySelector<HTMLDivElement>('div');
    if (!content) return;

    const isCollapsed = img.src.includes('collapse');

    if (isCollapsed) {
        img.src = img.src.replace('collapse', 'expand');
        content.style.display = 'none';
    } else {
        img.src = img.src.replace('expand', 'collapse');
        content.style.display = 'block';

        const groupPanel = parent.lastElementChild;
        if (!(groupPanel instanceof HTMLElement)) return;

        if (groupPanel.innerHTML === '') {
            const groupId = Number(groupPanel.id.replace('groupPanel_', ''));
            loadGroupData(groupId, PresentationDate);
        }
    }
}

/**
* Add hover funtions to every quarter
*/
export function addHoverFunctions(): void {
    for (let i = 1; i <= 96; i++) {
        const hour = Math.floor((i - 1) / 4);
        const quarter = ((i - 1) % 4) * 15;

        $('.stripes li:nth-child(' + i + ')')
            .on("mouseenter", function (e: any) { hoverCurrentQuarter(e, this, hour, quarter); })
            .on("mouseleave", function () { unhoverCurrentQuarter(hour, quarter); });
    }
}
